import React, { useState, useEffect } from 'react';
import './CollapsibleMenu.scss';

import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

export default function CollapsibleMenu(props) {

    const data = props.data;
    if(data.markComplete){
        props.markComplete();
    }

    const progress = props.progress

    // Takes in the course wide location object. Currently returns a string 
    // from the status state in Course.js. Eventually there will be an 
    // 'in-progress' state as well.
    const getSegmentStatus = locationObject => 
        progress?.modules[locationObject.module]
            .lessons[locationObject.lesson]
            .chapters[locationObject.chapter]
            .segments[locationObject.segment]
            .status;

    const [completedLessons] = useState(data.lessons.map(
            lesson => lesson.chapters.reduce(
                (isComplete, chapter) => 
                    !(getSegmentStatus(chapter.location) === 'complete') ? 'in-progress' : isComplete, 
                'complete')
        ));
    // useEffect(() => console.log(completedLessons), [completedLessons])

    const [completedChapters] = useState(data.lessons.map(
        lesson => lesson.chapters.map(
            chapter => getSegmentStatus(chapter.location))
            ));
    // useEffect(() => console.log(completedChapters), [completedChapters])

    const [selectedLessonId, setSelectedLessonId] = useState(null);

    const handleNavigation = (location) => {

        if(location){
            props.navigateTo(location)
        }
        else{
            console.log('location not valid')
        }

    }

    return (
        <InteractionContainer variant='starfield'>
            <div className={`collapsible-menu ${data.class}`}>

            <img className={`backgroundImage`} src={data.config.backgroundImage} alt='' />

            <div className="header-container">
                <div className="menu-header" style={{background: `left 1% no-repeat url(${data.config.headerBackground})`}}>
                    <h1>{data.config.header.toUpperCase()}</h1>
                </div>
                <div className="menu-text">
                    <p></p>
                </div>
            </div>

            <div className="menu-container">

                <div className="lesson-container">
                    {Array.isArray(data.lessons) && data.lessons.map((lesson, i) => {
                        const displayProp = {
                            display: lesson?.isHidden === true ? 'none' : '',
                        }
                        return  <div key={`menu-entry-${i}`} style={displayProp} className={`lesson`} onMouseOver={() => setSelectedLessonId(i)} >
                            
                            <div className={`lesson-title-and-line ${selectedLessonId === i ? 'selected' : 'not-selected'}`}>
                                <img className={`checkbox ${completedLessons[i] === 'complete' ? 'checked' : ''}`}
                                     src="media/img/icons/check-circle.svg" alt="" />
                                <div className="text" dangerouslySetInnerHTML={{__html: lesson.title}}></div>
                                {selectedLessonId === i && <div className="line"></div>}
                            </div>

                            {selectedLessonId === i && <div className="flying">
                                <div className={`chapter-container ${Array.isArray(data.lessons) && data.lessons[selectedLessonId].chapters.length > 8 ? "large" : ""}`}>
                                    {Array.isArray(data.lessons) && data.lessons[selectedLessonId].chapters.map((chapter, i) => {
                                        const displayProp = {
                                            display: chapter?.isHidden === true ? 'none' : '',
                                        }

                                        return (
                                            <div
                                                style={displayProp}
                                                key={i}
                                                className={`chapter `}
                                                onClick={() => handleNavigation(chapter.location)} >
                                                <img className={`icon`}
                                                    src={`media/img/icons/${completedChapters[selectedLessonId][i]}.svg`} 
                                                    alt="" />

                                                <div className="text"
                                                    dangerouslySetInnerHTML={{__html: chapter.title}} />

                                            </div>
                                        )
                                    })}

                                </div>

                            </div>}

                        </div>

                    })}
                </div>

                {/* {selectedLessonId !== null && asd} */}
            </div>
        </div>
        </InteractionContainer>
    )
}
